export const DEFAULT_VISIT_DURATION_MINUTES = 60;
export const MIN_VISIT_DURATION_MINUTES = 30;
export const MAX_VISIT_DURATION_MINUTES = 8 * 60;
export const VISIT_DURATION_INTERVAL_MINUTES = 30;
export type VisitType = 'maintenance' | 'service' | 'walkthrough';

export type VisitDurationDefaults = Record<VisitType, number>;

export const DEFAULT_VISIT_DURATION_BY_TYPE: VisitDurationDefaults = {
  walkthrough: 60,
  maintenance: 120,
  service: 120,
};

export const VISIT_DURATION_OPTIONS_MINUTES = Array.from(
  {
    length:
      (MAX_VISIT_DURATION_MINUTES - MIN_VISIT_DURATION_MINUTES) /
        VISIT_DURATION_INTERVAL_MINUTES +
      1,
  },
  (_, index) => MIN_VISIT_DURATION_MINUTES + index * VISIT_DURATION_INTERVAL_MINUTES,
);

export const formatVisitDurationLabel = (minutes: number) => {
  if (minutes < 60) return `${minutes} minutes`;
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (remainingMinutes === 0) return `${hours} hour${hours === 1 ? '' : 's'}`;
  return `${hours} hour${hours === 1 ? '' : 's'} ${remainingMinutes} minutes`;
};

export const isValidVisitDurationMinutes = (minutes: number) =>
  Number.isInteger(minutes) &&
  minutes >= MIN_VISIT_DURATION_MINUTES &&
  minutes <= MAX_VISIT_DURATION_MINUTES &&
  minutes % VISIT_DURATION_INTERVAL_MINUTES === 0;
